const initialState = {
  text: '',
  constituentDocuments: [],
};

const GET_CONSTITUENT_DOCUMENTS = 'GET_CONSTITUENT_DOCUMENTS';

export const constituentDocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONSTITUENT_DOCUMENTS:
      return { ...state, constituentDocuments: action.payload.files, text: action.payload.text };
    default:
      return state;
  }
};

export const getConstituentDocumentAction = (payload) => ({ type: GET_CONSTITUENT_DOCUMENTS, payload });
